/* FREQCREATE — comportamiento compartido entre secciones (nav, tema, buscador, scroll). */
(function () {
  /* Esta etiqueta <script src="fc-app.js"> aparece en más de una sección de la misma
     página (nav, kits, footer, etc). Cada <script src> se re-ejecuta cada vez que el
     parser la encuentra, así que sin este guard el IIFE completo corría una vez por
     sección incluida — y por ejemplo el botón de tema claro/oscuro quedaba con dos
     listeners duplicados: un click disparaba toggleTheme() dos veces seguidas y el
     tema volvía a su estado original, dando la sensación de que el botón "no hacía nada". */
  if (window.__fcAppBooted) return;
  window.__fcAppBooted = true;

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-fc-root]'));
  }

  function initTheme() {
    var saved = null;
    try { saved = localStorage.getItem('fc-theme'); } catch (e) {}
    if (saved === 'Oscuro' || saved === 'Claro') {
      roots().forEach(function (r) { r.setAttribute('data-fc-theme', saved); });
    }
  }

  function toggleTheme() {
    var current = roots()[0];
    var next = current && current.getAttribute('data-fc-theme') === 'Claro' ? 'Oscuro' : 'Claro';
    roots().forEach(function (r) { r.setAttribute('data-fc-theme', next); });
    try { localStorage.setItem('fc-theme', next); } catch (e) {}
  }

  function initRoot(root) {
    var themeBtn = root.querySelector('[data-fc-theme-toggle]');
    if (themeBtn) themeBtn.addEventListener('click', toggleTheme);

    var searchToggle = root.querySelector('[data-fc-search-toggle]');
    var searchPanel = root.querySelector('[data-fc-search]');
    var searchClose = root.querySelector('[data-fc-search-close]');
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        searchPanel.hidden = false;
        var input = searchPanel.querySelector('input');
        if (input) input.focus();
      });
    }
    if (searchClose && searchPanel) searchClose.addEventListener('click', function () { searchPanel.hidden = true; });
    if (searchPanel) searchPanel.addEventListener('click', function (e) { if (e.target === searchPanel) searchPanel.hidden = true; });

    /* Nav: interpolación continua ligada al scroll (0..140px), igual que el diseño original. */
    var navwrap = root.querySelector('[data-fc-navwrap]');
    if (navwrap) {
      var raf = null;
      var applyNav = function () {
        raf = null;
        var t = Math.max(0, Math.min(1, (window.scrollY || 0) / 140));
        navwrap.style.setProperty('--nav-t', t);
        if (t > 0.02) navwrap.classList.add('is-scrolled'); else navwrap.classList.remove('is-scrolled');
      };
      var onNavScroll = function () {
        if (raf) return;
        raf = requestAnimationFrame(applyNav);
      };
      window.addEventListener('scroll', onNavScroll, { passive: true });
      applyNav();
    }

    /* Nav: indicador deslizante detrás del link activo/hover. */
    var navLinksWrap = root.querySelector('[data-fc-nav-links]');
    var indicator = root.querySelector('[data-fc-nav-indicator]');
    if (navLinksWrap && indicator) {
      var links = Array.prototype.slice.call(navLinksWrap.querySelectorAll('a'));
      links.forEach(function (a) {
        a.addEventListener('mouseenter', function () {
          indicator.style.left = a.offsetLeft + 'px';
          indicator.style.width = a.offsetWidth + 'px';
          indicator.style.opacity = '1';
        });
      });
      navLinksWrap.addEventListener('mouseleave', function () {
        indicator.style.opacity = '0';
      });
    }

    /* Barra de progreso de scroll. */
    var progressFill = root.querySelector('[data-fc-progress-fill]');
    if (progressFill) {
      var updateProgress = function () {
        var doc = document.scrollingElement || document.documentElement;
        var max = Math.max(doc.scrollHeight - doc.clientHeight, 1);
        var pct = Math.min(100, ((doc.scrollTop || window.scrollY || 0) / max) * 100);
        progressFill.style.width = pct + '%';
      };
      window.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    }

    /* Métricas: conteo animado al entrar en pantalla. */
    var metricsScope = root.querySelector('[data-fc-metrics]');
    if (metricsScope && window.IntersectionObserver) {
      var nums = Array.prototype.slice.call(metricsScope.querySelectorAll('[data-count-to]'));
      if (nums.length) {
        var animated = false;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !animated) {
              animated = true;
              nums.forEach(function (el) {
                var target = parseFloat(el.getAttribute('data-count-to')) || 0;
                var dur = 1700;
                var t0 = null;
                var ease = function (x) { return 1 - Math.pow(1 - x, 3); };
                function step(ts) {
                  if (t0 === null) t0 = ts;
                  var p = Math.min(1, (ts - t0) / dur);
                  el.textContent = Math.round(target * ease(p));
                  if (p < 1) requestAnimationFrame(step);
                  else el.textContent = target;
                }
                requestAnimationFrame(step);
              });
              io.disconnect();
            }
          });
        }, { threshold: 0.35 });
        io.observe(metricsScope);
      }
    }
  }

  function boot() {
    initTheme();
    roots().forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
